// Contract addresses for different networks
export const CONTRACT_ADDRESSES = {
  // BSC Testnet (Chain ID: 97)
  97: {
    factory: import.meta.env.VITE_FACTORY_ADDRESS_TESTNET || '0xF307cac6bfAC46F63F56780d30F3a588b1544305',  // V8 UUPS Factory Proxy
    factoryImplementation: '0x65D379F59305908BD3F492336f01C9e89EF4d901', // V8 UUPS Factory Implementation
    template: '0xBFb2FCb76FD9387C8bB18e4996a51Fe607f03533', // V8 Template (Updated with percentage-based limits)
    router: import.meta.env.VITE_PANCAKESWAP_ROUTER_TESTNET || '0xD99D1c33F9fC3444f8101754aBC46c52416550D1', // PancakeSwap Testnet Router
  },
  // BSC Mainnet (Chain ID: 56)
  56: {
    factory: '0x13cFaDE4cA9cE6a70464408B374a5e576206ea0e',  // V8 UUPS Factory Proxy (No env override for security)
    factoryImplementation: '0x06896d9d19d56F00A2Fd68d34432aDEc165c23E3', // V8 UUPS Factory Implementation
    template: '0x5dfB8E3Ba44D9577CF1663146D9D42e0C71FF3a3', // V8 Template
    router: import.meta.env.VITE_PANCAKESWAP_ROUTER_MAINNET || '0x10ED43C718714eb63d5aA57B78B54704E256024E', // PancakeSwap Mainnet Router
  },
  // opBNB Testnet (Chain ID: 5611)
  5611: {
    factory: '0x33EE03e7926056514E8175A42C189E3ad12B9785',  // V8 UUPS Factory Proxy
    factoryImplementation: '0x2Ff6137d360c2F9C5CCcD0ECAfEB765d978205F4', // V8 UUPS Factory Implementation
    template: '0x3E77bDdeb35443E7098fF7AdbDE86b4866a79b5c', // V8 Template (No DEX integration for testnet)
    router: '0xB89a6778D1efE7a5b7096757A21b810CC2886fa1', // PancakeSwap V3 Universal Router (not used by template)
  },
  // opBNB Mainnet (Chain ID: 204)
  204: {
    factory: '0x93F8ee4244A7B0fBf6F52Bb022dA8549A555CA28',  // V8 UUPS Factory Proxy - MAINNET LIVE
    factoryImplementation: '0x05E8F342FB1dB4A86a160f580EB784ca32BEe07a', // V8 UUPS Factory Implementation
    template: '0xB1019Ff4c295d66443F3cbB48439d2239e0eD3bf', // V8 Template
    router: '0xB89a6778D1efE7a5b7096757A21b810CC2886fa1', // PancakeSwap V3 Universal Router
  },
  // Ethereum Mainnet (Chain ID: 1)
  1: {
    factory: '0x4FF205ef97ee528c8FB4bB36bA67Fd8a95e8b3f0',  // V8 UUPS Factory Proxy - MAINNET LIVE
    factoryImplementation: '0x9B99CDC7749Fc5611c2C811bB5dA4f7be0304049', // V8 UUPS Factory Implementation
    template: '0x361b08fa84cf4E8F1a80e20030a12215D449433A', // V8 Template - Individual locks
    router: import.meta.env.VITE_UNISWAP_ROUTER_MAINNET || '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D', // Uniswap V2 Router
  },
  // Sepolia Testnet (Chain ID: 11155111)
  11155111: {
    factory: '0x6206a0938568c3f3Bb2940A23a4AD6EF7132E709',  // V8 UUPS Factory Proxy
    factoryImplementation: '0x9D87B8Ea4CaEC6A3333FD92f245F989E9E41760f', // V8 UUPS Factory Implementation
    template: '0xB1c32249d20B00E111E96B6FDA334611Ad15010d', // V8 Template
    router: '0xC532a74256D3Db42D0Bf7a0400fEFDbad7694008', // Uniswap V2 Router
  },
  // Avalanche Fuji Testnet (Chain ID: 43113)
  43113: {
    factory: import.meta.env.VITE_FACTORY_ADDRESS_AVALANCHE_TESTNET || '0x660BD215c2832943b7311fAF5AF7D25d0137a8d3',
    factoryImplementation: '0x9f7F6910932596EDb7e22E99e6cbA51E15394793',
    template: '0x3D7259D928b8B6fd8A6508B713e5de03f2Da6586',
    router: import.meta.env.VITE_TRADERJOE_ROUTER_TESTNET || '0xd7f655E3376cE2D7A2b08fF01Eb3B1023191A901',
  },
  // Avalanche Mainnet (Chain ID: 43114)
  43114: {
    factory: import.meta.env.VITE_FACTORY_ADDRESS_AVALANCHE_MAINNET || '0x93F8ee4244A7B0fBf6F52Bb022dA8549A555CA28',
    factoryImplementation: '0x05E8F342FB1dB4A86a160f580EB784ca32BEe07a',
    template: '0xB1019Ff4c295d66443F3cbB48439d2239e0eD3bf',
    router: import.meta.env.VITE_TRADERJOE_ROUTER_MAINNET || '0x60aE616a2155Ee3d9A68541Ba4544862310933d4',
  },
  // Abstract Testnet (Chain ID: 11124)
  11124: {
    factory: '0x9b1bA2b0A646e15835830657f19914C02A18c91d',  // V8 UUPS Factory Proxy (Solidity 0.8.24 - Verifiable!)
    factoryImplementation: '0x9A543CCEd714783c370e1898584bEa12E67239a4', // V8 UUPS Factory Implementation
    template: '0x9eA59c6D370e678DFa68F8161Bc18baDD6112D6F', // V8 Template (Solidity 0.8.24 - Verifiable!)
    router: '0x96ff7D9dbf52FdcAe79157d3b249282c7FABd409', // Uniswap V2 Router
  },
  // Abstract Mainnet (Chain ID: 2741)
  2741: {
    factory: '0x9b1bA2b0A646e15835830657f19914C02A18c91d',  // V8 UUPS Factory Proxy (SimpleProxy with ERC1967 slots)
    factoryImplementation: '0x9A543CCEd714783c370e1898584bEa12E67239a4', // V8 UUPS Factory Implementation
    template: '0x312dc7227642e4948Db1D9228494d10c68dB1dfE', // V8 Template (Solidity 0.8.20)
    router: '0xad1eCa41E6F772bE3cb5A48A6141f9bcc1AF9F7c', // Uniswap V2 Router (Verified)
  },
  // Base Mainnet (Chain ID: 8453)
  8453: {
    factory: '0x93F8ee4244A7B0fBf6F52Bb022dA8549A555CA28',  // V8 UUPS Factory Proxy - MAINNET LIVE
    factoryImplementation: '0x05E8F342FB1dB4A86a160f580EB784ca32BEe07a', // V8 UUPS Factory Implementation
    template: '0xB1019Ff4c295d66443F3cbB48439d2239e0eD3bf', // V8 Template - Individual locks
    router: '0x327Df1E6de05895d2ab08513aaDD9313Fe505d86', // Uniswap V2 Router (BaseSwap)
  },
  // Base Sepolia (Chain ID: 84532)
  84532: {
    factory: '0x4D7d094508f451789d94AC0614A8375A75F9d56e',  // V8 UUPS Factory Proxy
    factoryImplementation: '0x51801002DA6600f7eA4c8E38178ed654dC85240B', // V8 UUPS Factory Implementation
    template: '0x33EE03e7926056514E8175A42C189E3ad12B9785', // V8 Template - Individual locks
    router: '0x4752ba5DBc23f44D87826276BF6Fd6b1C372aD24', // Uniswap V2 Router (BaseSwap)
  },
  // OP Mainnet (Chain ID: 10)
  10: {
    factory: '0xCC19185826AE5Cdf7DB4BF4F97b8BB7ad420a8F3',  // V8 UUPS Factory Proxy - MAINNET LIVE
    factoryImplementation: '0x93F8ee4244A7B0fBf6F52Bb022dA8549A555CA28', // V8 UUPS Factory Implementation
    template: '0x05E8F342FB1dB4A86a160f580EB784ca32BEe07a', // V8 Template - Individual locks
    router: '0x9c12939390052919aF3155f41Bf4160Fd3666A6f', // Velodrome Router
  },
  // OP Sepolia (Chain ID: 11155420)
  11155420: {
    factory: '0xCC19185826AE5Cdf7DB4BF4F97b8BB7ad420a8F3',
    factoryImplementation: '0x05E8F342FB1dB4A86a160f580EB784ca32BEe07a',
    template: '0x93F8ee4244A7B0fBf6F52Bb022dA8549A555CA28',
    router: '0x4A7b5Da61326A6379179b40d00F57E5bbDC962c2', // Uniswap V2 Router (Velodrome)
  },
  // Arbitrum One (Chain ID: 42161)
  42161: {
    factory: '0xCC19185826AE5Cdf7DB4BF4F97b8BB7ad420a8F3',  // V8 UUPS Factory Proxy - MAINNET LIVE
    factoryImplementation: '0x93F8ee4244A7B0fBf6F52Bb022dA8549A555CA28', // V8 UUPS Factory Implementation
    template: '0x05E8F342FB1dB4A86a160f580EB784ca32BEe07a', // V8 Template - Individual locks, no ongoing fee
    router: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506', // Uniswap V2 Router (SushiSwap)
  },
  // Arbitrum Sepolia (Chain ID: 421614)
  421614: {
    factory: '0x8468a165d633877270C5385D87D2dA656b948C8A',  // V8 UUPS Factory Proxy - Fixed trading delay lock conflict
    factoryImplementation: '0x9D87B8Ea4CaEC6A3333FD92f245F989E9E41760f', // V8 UUPS Factory Implementation
    template: '0x93aaa41E90982b6288E2ba4803f1Ac591C96cA82', // V8 Template - Separate locks for trading enabled and trading delay
    router: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506', // Uniswap V2 Router (SushiSwap)
  },
  // Polygon Mainnet (Chain ID: 137)
  137: {
    factory: '0x47d6A0B2a8E65ff135682A517372bEEf53607aF1',  // V8 UUPS Factory Proxy
    factoryImplementation: '0xCC19185826AE5Cdf7DB4BF4F97b8BB7ad420a8F3', // V8 UUPS Factory Implementation
    template: '0x93F8ee4244A7B0fBf6F52Bb022dA8549A555CA28', // V8 Template
    router: '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff', // QuickSwap Router
  },
  // Polygon Amoy Testnet (Chain ID: 80002)
  80002: {
    factory: '0x93F8ee4244A7B0fBf6F52Bb022dA8549A555CA28',  // V8 UUPS Factory Proxy
    factoryImplementation: '0x05E8F342FB1dB4A86a160f580EB784ca32BEe07a', // V8 UUPS Factory Implementation
    template: '0xB1019Ff4c295d66443F3cbB48439d2239e0eD3bf', // V8 Template
    router: '0xC532a74256D3Db42D0Bf7a0400fEFDbad7694008', // Uniswap V2 Router on Amoy
  },
  // Sei Atlantic-2 Testnet (Chain ID: 1328)
  1328: {
    factory: '0x93F8ee4244A7B0fBf6F52Bb022dA8549A555CA28',  // V8 UUPS Factory Proxy
    factoryImplementation: '0x05E8F342FB1dB4A86a160f580EB784ca32BEe07a', // V8 UUPS Factory Implementation
    template: '0xB1019Ff4c295d66443F3cbB48439d2239e0eD3bf', // V8 Template
    router: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D', // DragonSwap V2 Router
    dexFactory: '0x179D9a5592Bc77050796F7be28058c51cA575df4', // DragonSwap V2 Factory (for pair creation)
  },
  // Sei Pacific-1 Mainnet (Chain ID: 1329)
  1329: {
    factory: '0x47d6A0B2a8E65ff135682A517372bEEf53607aF1',  // V8 UUPS Factory Proxy - MAINNET LIVE
    factoryImplementation: '0xCC19185826AE5Cdf7DB4BF4F97b8BB7ad420a8F3', // V8 UUPS Factory Implementation
    template: '0x93F8ee4244A7B0fBf6F52Bb022dA8549A555CA28', // V8 Template
    router: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D', // DragonSwap V2 Router
    dexFactory: '0x179D9a5592Bc77050796F7be28058c51cA575df4', // DragonSwap V2 Factory (for pair creation)
  }
} as const;

// Helper to check if address is valid
const isValidAddress = (address: string) => {
  return typeof address === 'string' && /^0x[0-9a-fA-F]{40}$/.test(address);
}

// Helper to check if address is zero address (not deployed)
const isZeroAddress = (address: string) => {
  return address === '0x0000000000000000000000000000000000000000';
}

export const isValidContractAddresses = (chainId: number) => {
  const addresses = CONTRACT_ADDRESSES[chainId as keyof typeof CONTRACT_ADDRESSES];
  if (!addresses) return false;

  // Check that factory, implementation, and template are valid and not zero
  // Router can be zero (for networks without DEX integration)
  const requiredAddresses = [addresses.factory, addresses.factoryImplementation, addresses.template];
  const allRequiredValid = requiredAddresses.every(addr => isValidAddress(addr) && !isZeroAddress(addr));
  
  // Router just needs to be valid format (can be zero)
  const routerValid = isValidAddress(addresses.router);
  
  return allRequiredValid && routerValid;
}

// Verify contract addresses are valid
Object.entries(CONTRACT_ADDRESSES).forEach(([chainId, network]) => {
  if (network.factory && !isValidAddress(network.factory)) {
    console.error(`Invalid factory contract address for chain ${chainId}:`, network.factory);
  }
  if (network.factoryImplementation && !isValidAddress(network.factoryImplementation)) {
    console.error(`Invalid factory implementation contract address for chain ${chainId}:`, network.factoryImplementation);
  }
  if (network.template && !isValidAddress(network.template)) {
    console.error(`Invalid template contract address for chain ${chainId}:`, network.template);
  }
  if (network.router && !isValidAddress(network.router)) {
    console.error(`Invalid router contract address for chain ${chainId}:`, network.router);
  }
});
